<template>
  <div class="g-product-list">
    <v-container fluid>
      <v-infinite-scroll :loading="loading" @top="prevPage" @bottom="nextPage" :offset='20' class="infinity-panel">
        <v-layout row wrap class="products-filter">
          <div class="justify-space-between d-flex w-100 align-center group-location">
            <div class="location-select">
              <search-by-location @changeLocation="changeLocation"/>
            </div>
            <div v-if="isLogged" class="group-selection-box">
              <select-by-group @changeGroup="changeGroup"/>
            </div>
          </div>
          <div class="d-flex justify-end w-100 filter-checkbox-xs only-friend-sect">
            <div v-if="isLogged" class="filter-checkbox">
              <label class="g-checkbox only-friends-checkbox">
                <input type="checkbox" v-model="productsFilter.onlyFriends" @change="onlyFriend()">
                <span class="g-label mr-0">{{$t(`products.only_friend`)}}</span>
                <span class="checkmark"/>
              </label>
            </div>
          </div>
          <div class="d-flex">
            <v-flex class="filter-middle">
              <div class="filter-tags mb-10 mt-10" v-if="checkboxCategory">
                <v-chip v-for="(subCheckbox) in checkboxCategory.subcategories"
                        :key="subCheckbox.id"
                        v-if="mainSearch.filter.includes(subCheckbox.id)"
                >
                  <span>{{ subCheckbox.displayInfo.name }} <v-icon small @click="deleteCategoryFilter(subCheckbox.id)">clear</v-icon></span>
                </v-chip>
              </div>
            </v-flex>
          </div>
          <div class="loader-selector">
            <v-progress-linear height="2" :indeterminate="productsUploadProgress" v-if="productsUploadProgress"/>
            <span class="loader-line"/>
          </div>
        </v-layout>
        <v-layout row wrap class="g-card scroll-product-sect">
            <v-flex v-if="(loadedProducts && items.length === 0) || emptyData">
              <div class="emptyproduct">
                <img class="emptyImg mb-2" src="../../assets/images/empty.svg" alt="">
                <h3 class="text-center font-weight-medium">
                  {{$t('no_matching_items_found')}}
                </h3>
              </div>
            </v-flex>
          <v-flex xs12 sm6 md4 lg3 v-if="!emptyData" v-for="(item, index) in visiblePages" :key="item.label" :class="{ 'ex-height' : items.length <= 4 }"
                  class="g-product-list-item">
            <v-card>
              <router-link :to="'/products/' + item.id + '/' + item.displayDetails.name.replace(/\s+/g, '-')">
                <v-layout class="g-item-list">
                  <div v-if="item.image" @click = "$router.push('/products/' + item.id + '/' + item.displayDetails.name.replace(/\s+/g, '-'))" class="g-card-img1" >
                    <img :src="`${ROOT_API}${item.image}`" :alt="item.displayDetails.name">
                  </div>
                 <div v-else @click = "$router.push('/products/' + item.id  + '/' + item.displayDetails.name.replace(/\s+/g, '-'))" class="g-card-img1" >
                   <img src="../../assets/images/default.svg" alt="Default image">
                 </div>
                  <span v-if="item.approved === 0" style="color: #4E8EF5;font-size: 17px;" class="g-filter1 text-center">{{$t('products.waiting')}}</span>
                  <span v-else-if="item.approved === 2" style="color: red;font-size: 17px;" class="g-filter1 text-center">{{$t('products.rejected')}}</span>
                  <v-list-tile-avatar v-if="item.User" class="g-filter">
                    <router-link :to="'/accounts/' + item.User.id" class="prouduct-avatar">
                      <img v-if="item.User.image" :src="`${ROOT_API}${item.User.image}`" alt="User image">
                      <i v-else class="material-icons">
                        account_circle
                      </i>
                    </router-link>
                  </v-list-tile-avatar>
                </v-layout>
              </router-link>
              <v-layout fill-height class="g-header">
                <v-flex xs12 class="product-title">
                  <router-link :to="'/products/' + item.id  + '/' + item.displayDetails.name.replace(/\s+/g, '-')" class="headline prod-title-name"> {{ item.displayDetails.name }}</router-link>
                  <button class="ex-fav-good" @click="addToFavorite(item, index)"><i :class="{ 'icon-favorite-2': item.favorite, 'icon-favorite-1': !item.favorite }"/></button>
                </v-flex>
              </v-layout>
              <v-layout class="ex-address">
                <i class="icon-location"/>
                {{ (item.displayDetails && item.displayDetails.location) ? item.displayDetails.location : '' }}
              </v-layout>
              <v-layout class="ex-good-description">
                {{ item.displayDetails.description }}
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-infinite-scroll>
      <div class="text-center">
        <v-pagination v-if="visiblePages.length > 0 && !emptyData"
          v-model="page"
          :total-visible="7"
          :length="Math.ceil(items.length/perPage)"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {EventBus} from '../../event-bus'
import SearchByLocation from './SearchByLocation'
import SelectByGroup from './SelectByGroup'
import infiniteScroll from 'v-infinite-scroll'
import {changeImageSize, validateJson, createLocation} from '../../helpers/main'

export default {
  name: 'Products-list',
  components: {
    'v-infinite-scroll': infiniteScroll,
    SearchByLocation,
    SelectByGroup
  },
  data: () => ({
    page: 1,
    perPage: 16,
    loadingSearch: false,
    showPreloading: false,
    loadedProducts: false,
    emptyData: false,
    loading: false,
    isLogged: false,
    items: [],
    ROOT_API: process.env.ROOT_API,
    productsUploadProgress: false,
    checkboxCategory: null,
    categoryIdActive: null,
    sendRequestInterval: true,
    productsSearch: {
      searchText: undefined,
      searchMove: false
    },
    productsPage: {
      itemsLoadedPages: [],

      page: 1,
      limit: 16,
      backPage: 0,
      favorite: false,

      scrollPrevPage: true,
      scrollNextPage: true,

      nextPageSetTimeout: ''
    },
    productsFilter: {
      buttonGroup: [],
      productsWhereIn: [],
      firstFiltrationRun: false,
      onlyFriends: false,
      locationId: null,
      groupId: null,
      favorite: false
    },
    typingTimer: {}
  }),
  computed: {
    ...mapState({
      loggedUser: state => state.auth.userData,
      categories: state => state.categories.list,
      mainSearch: state => state.categories.mainSearch,
      favorite: state => state.categories.favorite
    }),
    visiblePages () {
      return this.items.slice((this.page - 1) * this.perPage, this.page * this.perPage)
    }
  },
  created () {
    EventBus.$off('select-deselect-category')
    EventBus.$off('select-favorite')
    EventBus.$on('language-changed', this.languageChanged)
    EventBus.$on('select-deselect-category', this.selectedDeselectedCategory)
    EventBus.$on('select-favorite', this.selectedFavoriteProduct)
  },
  beforeMount () {
    if (localStorage && localStorage.getItem('token')) {
      this.isLogged = true
    }
    const parseIntLimit = parseInt(this.$route.query.limit)
    const parseIntPage = parseInt(this.$route.query.page)
    const routeQuerySearch = this.$route.query.search
    if (this.$route.query && this.$route.query.cat) {
      this.categoryIdActive = this.$route.query.cat === 'others' ? 'others' : parseInt(this.$route.query.cat) // Not parse as we have catId = 'others'
    }

    const filter = this.$route.query.filter || ''
    let json = '[' + filter + ']'
    this.productsFilter.buttonGroup = validateJson(json) ? JSON.parse(json) : []

    parseIntLimit ? (parseIntLimit > 25 ? this.productsPage.limit = 16 : this.productsPage.limit = parseIntLimit) : this.productsPage.limit = 16
    parseIntPage ? (parseIntPage < 1 ? this.productsPage.page = 1 : this.productsPage.page = parseIntPage) : this.productsPage.page = 1
    routeQuerySearch === undefined ? this.productsSearch.searchText = undefined : this.productsSearch.searchText = routeQuerySearch
    this.productsPage.itemsLoadedPages.push(this.productsPage.page)
    if (this.productsPage.page) {
      this.productsPage.backPage = this.productsPage.page
    }
    this.setMainSearchData() // Save MainSearch data in state
  },
  updated () {
    window.addEventListener('scroll', this._listenerScrolls, true)
  },
  destroyed () {
    window.removeEventListener('scroll', this._listenerScrolls, true)
  },
  methods: {
    _listenerScrolls () {
      let y = window.scrollY
      y > 50 && this.nextPage()
    },
    selectedFavoriteProduct () {
      this.setProductsPageDefaultValues()
      this.productsFilter.favorite = true
      this.items = []
      this.getUnprocessedProducts('', this.productsPage.page, this.productsPage.limit, this.productsFilter.productsWhereIn)
    },
    keyupIndividualName () {
      this.loadingSearch = true
      clearTimeout(this.typingTimer)
      this.typingTimer = setTimeout(() => {
        // Set default productsPage settings
        this.setProductsPageDefaultValues()
        this.productsSearch.searchMove = true
        this.getUnprocessedProducts(this.productsSearch.searchText, this.productsPage.page, this.productsPage.limit, this.productsFilter.productsWhereIn)
      }, 2500)
    },
    keydownIndividualName () {
      clearTimeout(this.typingTimer)
    },
    prevPage () {
      if (this.productsPage.backPage > 1 && this.productsPage.scrollPrevPage) {
        --this.productsPage.backPage
        if (!this.productsPage.itemsLoadedPages.includes(this.productsPage.backPage)) {
          this.getUnprocessedProducts(this.productsSearch.searchText, this.productsPage.backPage, this.productsPage.limit, this.productsFilter.productsWhereIn)
          this.productsPage.itemsLoadedPages.push(this.productsPage.backPage)
          setTimeout(() => {
            this.productsPage.scrollPrevPage = true
          }, 2000)
        }
        this.productsPage.scrollPrevPage = false
      }
    },
    nextPage () {
      if (this.productsPage.scrollNextPage) {
        this.productsPage.backPage = this.productsPage.page
        ++this.productsPage.page
        if (!this.productsPage.itemsLoadedPages.includes(this.productsPage.page)) {
          this.getUnprocessedProducts(this.productsSearch.searchText, this.productsPage.page, this.productsPage.limit, this.productsFilter.productsWhereIn)
          this.productsPage.itemsLoadedPages.push(this.productsPage.page)
          this.productsPage.nextPageSetTimeout = setTimeout(() => {
            this.productsPage.scrollNextPage = true
          }, 2000)
        }
        this.productsPage.scrollNextPage = false
      }
    },
    getProductList (products, page) {
      this.loadedProducts = false
      this.showPreloading = true
      let _products = []
      products.forEach(product => {
        product.image = changeImageSize(product.image, 'md')
        product.displayDetails = {}
        product.favorite = false
        product.ProductTranslations.forEach(productTranslation => {
          if (productTranslation.languageId === this.$store.getters['common/getActiveLanguage'].id) {
            if (productTranslation.name.match(/և/)) {
              productTranslation.name = productTranslation.name.replace('և', 'եվ').replace(/,\s*$/, '')
              product.displayDetails.name = productTranslation.name
            }
            product.displayDetails.name = productTranslation.name
            product.displayDetails.description = productTranslation.description.length > 75 ? productTranslation.description = productTranslation.description.substring(0, 75) + '...' : productTranslation.description
          } else if (!product.displayDetails.name) {
            product.displayDetails.name = productTranslation.name
            product.displayDetails.description = productTranslation.description.length > 75 ? productTranslation.description = productTranslation.description.substring(0, 75) + '...' : productTranslation.description
          }
        })
        product.ProductAddresses.forEach(productAddress => {
          let addressData = productAddress.Address
          if (productAddress.languageId === this.$store.getters['common/getActiveLanguage'].id) {
            product.displayDetails.location = createLocation(addressData)
          } else if (!product.displayDetails.location) {
            product.displayDetails.location = createLocation(addressData)
          }
        })
        if (product.FavoriteProducts && product.FavoriteProducts.length > 0) {
          product.FavoriteProducts.forEach(favoriteProduct => {
            if (favoriteProduct.userId === this.loggedUser.id) {
              product.favorite = true
            } else {
              product.favorite = false
            }
          })
        }
        _products.push(product)
      })

      if (products.length < this.productsPage.limit && this.productsPage.limit > 1) {
        this.productsPage.scrollNextPage = false
        clearInterval(this.productsPage.nextPageSetTimeout)
      }
      if (this.productsPage.limit === 1 && !_products.length && !this.productsFilter.firstFiltrationRun) {
        this.productsPage.page -= 1
        this.productsPage.scrollNextPage = false
        clearInterval(this.productsPage.nextPageSetTimeout)
      }

      let concatItems = false
      if (page === this.productsPage.page && !this.productsFilter.firstFiltrationRun) {
        if (this.productsSearch.searchMove) {
          this.productsSearch.searchMove = false
        } else {
          concatItems = true
        }
      } else if (page === this.productsPage.backPage && !this.productsFilter.firstFiltrationRun) {
        concatItems = true
      } else if (this.productsFilter.firstFiltrationRun) {
        this.productsFilter.firstFiltrationRun = false
      }

      let loadSetTimeouth = setTimeout(() => {
        if (concatItems) {
          this.items = this.items.concat(_products)
        } else {
          this.items = _products
        }
        this.productsUploadProgress = false
        this.loadedProducts = true
        this.loadingSearch = false
        this.showPreloading = false
        clearTimeout(loadSetTimeouth)
      }, 1000)
    },
    getUnprocessedProducts (search, page, limit, filter) {
      let query = {}
      if (this.mainSearch.cat) {
        query.cat = this.mainSearch.cat
      }
      if (this.mainSearch.filter.length > 0) {
        query.filter = `${this.mainSearch.filter}`
      }
      if (search) {
        query.search = search
      }
      if (this.productsFilter.locationId) {
        query.location = this.productsFilter.locationId
      }
      query.page = page
      query.limit = this.productsPage.limit
      this.$router.push({name: 'products', query: query})

      let _payload
      if (search && filter) {
        _payload = `filter=${filter}&search=${search}&page=${page}&limit=${limit}`
      } else if (search) {
        _payload = `search=${search}&page=${page}&limit=${limit}`
      } else if (filter) {
        _payload = `filter=${filter}&page=${page}&limit=${limit}`
      } else {
        _payload = `page=${page}&limit=${limit}`
      }
      if (this.productsFilter.locationId) {
        _payload += `&location=${this.productsFilter.locationId}`
      }

      this.productsUploadProgress = true
      if (this.isLogged) {
        if (this.productsFilter.onlyFriends) {
          _payload += `&friends=${this.productsFilter.onlyFriends}`
        }
        if (this.favorite) {
          this.productsFilter.favorite = this.favorite
          _payload += `&favorite=${this.productsFilter.favorite}`
        }
        if (this.productsFilter.groupId) {
          _payload += `&group=${this.productsFilter.groupId}`
        } else if (this.productsFilter.groupId === 0) {
          _payload += `&group=all`
        }
        return this.$store.dispatch('products/listWithFriends', _payload).then((res) => {
          this.getProductList(res.data.products, page)
        }).catch(err => {
          console.error(err)
        })
      } else {
        return this.$store.dispatch('products/list', _payload).then((res) => {
          this.getProductList(res.data.products, page)
        }).catch(err => {
          console.error(err)
        })
      }
    },
    setMainSearchData () {
      let data = {
        cat: this.categoryIdActive,
        filter: Object.assign([], this.productsFilter.buttonGroup)
      }
      this.$store.dispatch('categories/setMainSearchData', data)
    },
    languageChanged () {
      this.getProductList(this.items)
      this.changeFiltersLang()
    },
    changeFiltersLang () {
      if (this.checkboxCategory) {
        this.categories.forEach((item, i) => {
          if (this.checkboxCategory.id === item.id) {
            this.checkboxCategory = item
          }
        })
      }
    },
    onlyFriend () {
      this.setProductsPageDefaultValues()
      this.getUnprocessedProducts(this.productsSearch.searchText, this.productsPage.page, this.productsPage.limit, this.productsFilter.productsWhereIn)
    },
    changeLocation (locationId) {
      if (locationId) {
        let locationData = {
          id: locationId,
          isLogged: this.isLogged
        }
        this.$store.dispatch('products/getAddressTranslations', locationData).then(response => {
          this.productsPage.scrollPrevPage = false
          this.productsPage.scrollNextPage = false
          this.getProductList(response.products)
          this.emptyData = false
        }).catch(err => {
          console.log(err)
        })
      } else if (locationId === 0) {
        this.emptyData = true
      } else {
        this.emptyData = false
        this.page = 1
        this.setProductsPageDefaultValues()
        this.getUnprocessedProducts(this.productsSearch.searchText, this.productsPage.page, this.productsPage.limit, this.productsFilter.productsWhereIn)
      }
    },
    changeGroup (groupId) {
      this.productsFilter.groupId = groupId
      this.setProductsPageDefaultValues()
      this.getUnprocessedProducts(this.productsSearch.searchText, this.productsPage.page, this.productsPage.limit, this.productsFilter.productsWhereIn)
    },
    deleteCategoryFilter (subCatId) {
      let indexOf = this.productsFilter.productsWhereIn.indexOf(subCatId)
      this.productsFilter.productsWhereIn.splice(indexOf, 1)
      EventBus.$emit('delete-checkbox', {productsWhereIn: this.productsFilter.productsWhereIn})
    },
    selectedDeselectedCategory (cat) {
      // Set default productsPage settings
      this.setProductsPageDefaultValues()
      this.productsSearch.searchText = this.mainSearch.name
      this.$store.dispatch('categories/setSearch', {name: null})
      if (cat.productsWhereIn) {
        this.productsFilter.productsWhereIn = cat.productsWhereIn
      }
      this.checkboxCategory = cat.checkboxCategory ? cat.checkboxCategory : []
      if (cat.productsWhereIn !== undefined) {
        this.getUnprocessedProducts(this.productsSearch.searchText, this.productsPage.page, this.productsPage.limit, cat.productsWhereIn)
      }
    },
    setProductsPageDefaultValues () {
      this.productsPage.scrollPrevPage = true
      this.productsPage.scrollNextPage = true
      this.productsPage.page = 1
      this.productsPage.backPage = 0
      this.productsPage.limit = 16
      this.productsFilter.firstFiltrationRun = true
      this.productsPage.itemsLoadedPages = [this.productsPage.page]
    },
    addToFavorite (item, index) {
      if (this.isLogged) {
        this.$store.dispatch('products/addToFavorite', item.id).then((res) => {
          if (res.type === 'success') {
            this.items[index].favorite = !this.items[index].favorite
            if (this.items[index].favorite === true) {
              this.items[index].FavoriteProducts.push({id: item.id, userId: this.loggedUser.id})
            } else {
              this.items[index].FavoriteProducts = []
            }
            this.$toastr(res.type, res.message, this.$t(res.type))
          } else {
            this.$toastr('error', this.$t('something_went_wrong'), this.$t('error'))
          }
        }).catch(console.error)
      } else {
        this.$emit('openLogModal')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/sass/desktop/products.scss";
</style>



// WEBPACK FOOTER //
// src/components/products/productList.vue